import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export default /*#__PURE__*/_defineComponent({
  props: {
    isPadding: {
      type: Boolean,
      default: true
    }
  },

  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["float-container", [__props.isPadding]])
      }, [_renderSlot(_ctx.$slots, "default")], 2);
    };
  }

});